import { Button, ButtonDesign, MessageBox, MessageBoxTypes } from '@ui5/webcomponents-react';
import { useTranslation } from 'react-i18next';
import '@ui5/webcomponents-icons/dist/complete';
import { Status, useDiscontinueQueryByIdMutation } from 'generated/graphql';
import { useUpdateBaseQueryStore } from 'stores/UpdateBaseQueryStore';
import { useState } from 'react';
import { ResultUserMessage } from 'components/shared/UserMessage';
import { createPortal } from 'react-dom';

export interface DiscontinueQueryProps {
  id: string;
  setResultMessage: (value: ResultUserMessage) => void;
  setIsUserMessageOpen: (value: boolean) => void;
}

export const DiscontinueQuery: React.FC<DiscontinueQueryProps> = (props) => {
  const { id, setResultMessage, setIsUserMessageOpen } = props;
  const { t } = useTranslation();
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);

  const [, discontinueQueryMutation] = useDiscontinueQueryByIdMutation();
  const baseQueryStore = useUpdateBaseQueryStore();

  const discontinueQuery = async () => {
    const { error } = await discontinueQueryMutation({ id });
    if (error) {
      setResultMessage({
        isSuccess: false,
        message: t('display-query-actions-discontinue-error')
      });
    } else {
      baseQueryStore.setSelectedStatus(Status.CLOSED);
      setResultMessage({
        isSuccess: true,
        message: t('display-query-actions-discontinue-success')
      });
    }
    setIsUserMessageOpen(true);
  };

  const renderConfirmationDialog = () => {
    return createPortal(
      <MessageBox
        open={isConfirmDialogOpen}
        type={MessageBoxTypes.Confirm}
        onClose={() => setIsConfirmDialogOpen(false)}
        actions={[
          <Button
            key="confirm-discontinue-query-button"
            id="confirm-discontinue-query-button"
            data-testid="confirm-discontinue-query-button"
            onClick={discontinueQuery}
            design={ButtonDesign.Default}
          >
            {t('confirm')}
          </Button>,
          <Button
            key="cancel-discontinue-query-button"
            id="cancel-discontinue-query-button"
            data-testid="cancel-discontinue-query-button"
            design={ButtonDesign.Emphasized}
          >
            {t('cancel')}
          </Button>
        ]}
        data-testid="display-query-actions-confirm-dialog-discontinue"
      >
        {t('display-query-actions-confirm-dialog-discontinue')}
      </MessageBox>,
      document.body
    );
  };

  return (
    <>
      <Button
        className={'button-bg-white'}
        data-testid="display-query-discontinue-query"
        data-help-id="display-query-discontinue-query"
        id="edit-query-button"
        onClick={() => setIsConfirmDialogOpen(true)}
        design={ButtonDesign.Negative}
      >
        {t('display-query-discontinue-query')}
      </Button>
      {renderConfirmationDialog()}
    </>
  );
};
